import React from "react";
import InterviewStore from "./interview_store";
import UserStore from "./user_store";
import FeedbackStore from "./feedback_store";
import CommonStore from "./common_store";
import LearningStore from "./learning_store";
import PopupStore from "./popups_store";
import ResumeStore from "./resume_store";
import RecuiterStore from "./recuiter_store";
import CompanyInterviewsStore from "./company_interviews";
import MockStore from "./mock_test_store";
import LabelStore from "./label_store";
class RootStore {
  constructor() {
    this.InterviewStore = new InterviewStore(this);
    this.UserStore = new UserStore(this);
    this.FeedbackStore = new FeedbackStore(this);
    this.CommonStore = new CommonStore(this);
    this.LearningStore = new LearningStore(this);
    this.PopupStore = new PopupStore(this);
    this.ResumeStore = new ResumeStore(this);
    this.RecuiterStore = new RecuiterStore(this);
    this.CompanyInterviewsStore = new CompanyInterviewsStore(this);
    this.MockStore = new MockStore(this);
    this.LabelStore = new LabelStore(this);
  }
}
export const rootStore = new RootStore();
const StoresContext = React.createContext(rootStore);
export const useStores = () => React.useContext(StoresContext);
